/* LILINMOMO section-storybook-spotlight.js — Chat 04 §9.4
   Palette pills instantly recolor the preview rainbow (no animation between palettes).
   Colors are set as inline style.stroke (overrides the CSS [data-rainbow-scope] default)
   on the band paths inside the scope, so the retro palette never leaks to site chrome.
   mount/unmount honor Dawn's shopify:section:load / :unload re-render contract. */

(function () {

  function mount(root) {
    var scope = root.querySelector('[data-rainbow-scope]');
    if (!scope) return;

    var bands = Array.prototype.slice.call(scope.querySelectorAll('.spot-band'));
    var pills = Array.prototype.slice.call(root.querySelectorAll('.spotlight-pills button'));
    if (!bands.length || !pills.length) return;

    function selectPill(pill) {
      var colors = (pill.dataset.colors || '').split(',').map(function (c) { return c.trim(); });
      bands.forEach(function (band, i) {
        if (colors[i]) band.style.stroke = colors[i];
      });
      pills.forEach(function (p) {
        p.setAttribute('aria-pressed', p === pill ? 'true' : 'false');
      });
    }

    pills.forEach(function (pill) {
      pill._lmHandler = function () { selectPill(pill); };
      pill.addEventListener('click', pill._lmHandler);
    });

    // Initialize from the pressed pill (or the first) — instant, no transition.
    var active = pills.filter(function (p) {
      return p.getAttribute('aria-pressed') === 'true';
    })[0] || pills[0];
    selectPill(active);
  }

  function unmount(root) {
    var pills = root.querySelectorAll('.spotlight-pills button');
    pills.forEach(function (pill) {
      if (pill._lmHandler) {
        pill.removeEventListener('click', pill._lmHandler);
        pill._lmHandler = null;
      }
    });
  }

  // First paint
  document.querySelectorAll('.section-spotlight').forEach(mount);

  // Theme editor re-render contract
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.classList.contains('section-spotlight')) mount(e.target);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    if (e.target.classList.contains('section-spotlight')) unmount(e.target);
  });
})();
